// extracted by mini-css-extract-plugin
module.exports = {"desktopWidth":"1024px","gapExtraSmall":".45rem","gapLarge":".9rem"};